import React from "react";
import "./styles/style.scss";
import withProviders from "./providers";
import { Routing } from "../new-folder-structure/pages";

function App() {
  return <Routing />;
}
export default withProviders(App);
